import { SidenavItem } from '@layout/sidenav/sidenav-item/sidenav-item.interface';

/**
 * Atalho para abrir um pedido no e-SIC da mesma entidade. Só entra no menu quando a entidade tem
 * e-SIC e a pessoa é cidadã cadastrada nela — ver `podeAbrirPedidoNoEsic`, a mesma regra do
 * cartão "Solicitação" da tela principal. Por isso fica fora da lista fixa.
 */
export const CIDADAO_SIDENAV_ITEM_ESIC: SidenavItem = {
  name: 'Solicitação',
  routeOrFunction: '/modulo/esic/cidadao/registrarpedido',
  icon: 'description',
  position: 60,
};

export const CIDADAO_SIDENAV_ITEMS: SidenavItem[] = [
  {
    name: 'PRINCIPAL',
    position: 5,
    type: 'subheading',
    customClass: 'first-subheading'
  },
  {
    name: 'Início',
    routeOrFunction: '/modulo/ouvidoria/cidadao/principal',
    icon: 'home',
    position: 10,
    pathMatchExact: true
  },
  {
    name: 'Elogio',
    routeOrFunction: '/modulo/ouvidoria/cidadao/manifestacao',
    queryParams: { tipo: 'ELOGIO' },
    icon: 'thumb_up',
    position: 20,
  },
  {
    name: 'Denúncia',
    routeOrFunction: '/modulo/ouvidoria/cidadao/manifestacao',
    queryParams: { tipo: 'DENUNCIA' },
    icon: 'report',
    position: 30,
  },
  {
    name: 'Reclamação',
    routeOrFunction: '/modulo/ouvidoria/cidadao/manifestacao',
    queryParams: { tipo: 'RECLAMACAO' },
    icon: 'campaign',
    position: 40,
  },
  {
    name: 'Sugestão',
    routeOrFunction: '/modulo/ouvidoria/cidadao/manifestacao',
    queryParams: { tipo: 'SUGESTACAO' },
    icon: 'chat',
    position: 50,
  },
  {
    name: 'Consultar',
    routeOrFunction: '/modulo/ouvidoria/cidadao/manifestacao/consulta',
    icon: 'search',
    position: 70,
  },
];
